import type { FormElementComposerProps } from '@lemonade-hq/cdk';
import type { ChipsProps } from '@lemonade-hq/uniclient-theme';
import type { UniclientAction } from '../../../action';
import type { BaseFormComposerProps } from './types';

export const CHIPS_CURRENT_ITEM_ATTRIBUTE = '__chipsCurrentItem__';

export type FormChipsComposerConfigurableProps = {
  readonly addAction?: UniclientAction;
  readonly removeAction?: UniclientAction;
  readonly passive?: boolean;
  readonly itemTemplate: Pick<ChipsProps, 'icon' | 'label' | 'passive'> & {
    readonly removable?: boolean;
    readonly editable?: boolean;
  };
};
export type FormChipsComposerBaseProps = FormElementComposerProps<unknown>;

export type FormChipsComposerProps = BaseFormComposerProps &
  FormChipsComposerBaseProps &
  FormChipsComposerConfigurableProps;
